const TYPE = 'ps.StationTimeline'

function create() {
  return {
    type : TYPE
  }
}

export default {
  create,
  TYPE
}
